import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../../utils/breakpoint";
import getIconColor from "../../../../utils/getIconColor";
import AbsoluteContainerOrg from "../../AbsoluteContainerOrg";
import FlexContainerOrg from "../../FlexContainerOrg";
import PushOrg from "../../PushOrg";
import { backgroundColor } from "../DevicesPreviewModalOrg.styled";
var DesktopIconSvg = function DesktopIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.334 21.333h21.333V6.667H5.334v14.666Zm12 2.667v2.667h5.333v2.666H9.334v-2.666h5.333V24H3.99a1.33 1.33 0 0 1-1.323-1.343V5.343C2.667 4.6 3.274 4 3.99 4H28.01c.73 0 1.323.599 1.323 1.343v17.314c0 .742-.607 1.343-1.323 1.343H17.334Z"
  }));
};
DesktopIconSvg.defaultProps = {
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
var MobileIconSvg = function MobileIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 7.346V24.654H22V7.345H10.8ZM9.2 4.8h14.4c.318 0 .623.118.848.328.226.21.352.495.352.792v20.16c0 .297-.126.582-.352.792-.224.21-.53.328-.848.328H9.2c-.318 0-.623-.118-.849-.328A1.083 1.083 0 0 1 8 26.08V5.92c0-.297.126-.582.351-.792.226-.21.53-.328.849-.328Zm7.2 16.8c.318 0 .623.118.849.328.225.21.351.495.351.792 0 .297-.126.582-.352.792-.225.21-.53.328-.848.328-.318 0-.623-.118-.848-.328a1.083 1.083 0 0 1-.352-.792c0-.297.126-.582.352-.792.225-.21.53-.328.848-.328Z"
  }));
};
MobileIconSvg.defaultProps = {
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
var TabletIconSvg = function TabletIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333v21.334h16V5.333H8ZM6.666 2.667h18.667A1.333 1.333 0 0 1 26.666 4v24a1.333 1.333 0 0 1-1.333 1.333H6.666A1.334 1.334 0 0 1 5.333 28V4a1.333 1.333 0 0 1 1.333-1.333Zm9.334 20a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666Z"
  }));
};
TabletIconSvg.defaultProps = {
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
export var StyledFlexContainerOrg = styled(FlexContainerOrg).withConfig({
  componentId: "sc-1446d1c-0"
})(["", "{justify-content:space-between;}"], breakpoint("small", "medium"));
export var StyledPushOrg = styled(PushOrg).withConfig({
  componentId: "sc-1446d1c-1"
})(["", "{display:none;}"], breakpoint("small", "medium"));
export var StyledAbsoluteContainerOrg = styled(AbsoluteContainerOrg).withConfig({
  componentId: "sc-1446d1c-2"
})(["top:50%;transform:translateY(-50%);", "{position:relative;transform:none;}"], breakpoint("small", "medium"));
export var DesktopIcon = styled(DesktopIconSvg).withConfig({
  componentId: "sc-1446d1c-3"
})(function (_ref) {
  var theme = _ref.theme,
    $active = _ref.$active;
  return css(["fill:", ";"], getIconColor(theme, backgroundColor, $active ? "high" : "low"));
});
export var TabletIcon = styled(TabletIconSvg).withConfig({
  componentId: "sc-1446d1c-4"
})(function (_ref2) {
  var theme = _ref2.theme,
    $active = _ref2.$active;
  return css(["fill:", ";"], getIconColor(theme, backgroundColor, $active ? "high" : "low"));
});
export var MobileIcon = styled(MobileIconSvg).withConfig({
  componentId: "sc-1446d1c-5"
})(function (_ref3) {
  var theme = _ref3.theme,
    $active = _ref3.$active;
  return css(["fill:", ";"], getIconColor(theme, backgroundColor, $active ? "high" : "low"));
});